import './Page.css'

export default function Page ({ children }: React.PropsWithChildren<{}>) {
  return <div className="Page">
    {children}
  </div>
}